import { Money } from '../../api/types';

const NANOS_PER_DOLLAR = 1_000_000_000;

/**
 * Convert a dollar amount (e.g. 90.0, 9.50) to a Google-standard Money proto.
 * Splits the value into whole-dollar `units` (string) and sub-dollar `nanos`
 * (1e-9 increments). The currency is fixed to USD.
 */
export const dollarsToMoney = (
  dollars: number,
  currencyCode = 'USD',
): Money => {
  const sign = dollars < 0 ? -1 : 1;
  const abs = Math.abs(dollars);
  const wholeUnits = Math.trunc(abs);
  const fractional = abs - wholeUnits;
  const nanos = Math.round(fractional * NANOS_PER_DOLLAR);
  return {
    currencyCode,
    units: String(sign * wholeUnits),
    nanos: sign * nanos,
  };
};
